import './App.css';
import { Routes, Route} from 'react-router-dom';
/* import { useState } from 'react'; */
import Landing from './components/Landing';
import Auth from './components/Auth';
import CustomerHome from './components/Customer/CustomerHome';
import MyRequests from './components/Customer/MyRequests';
import PlumberProfile from './components/Customer/PlumberProfile';
import JobDetails from './components/Customer/JobDetails';
import BookingSchedule from './components/Customer/BookingSchedule';
import Payment from './components/Customer/Payment';
import OrderStatus from './components/Customer/OrderStatus';
import Review from './components/Customer/Review';
import TaskerDashboard from './components/Plumber/TaskerDashboard';
import TaskerProfileEdit from './components/Plumber/TaskerProfileEdit';
import CustomerProfileEdit from './components/Customer/CustomerProfileEdit';
import JobRequest from './components/Plumber/JobRequest';
import TaskerEarnings from './components/Plumber/TaskerEraning';
import AdminDashboard from './Admin/AdminDashboard';
import RequireAuth from './components/RequireAuth';
import { useAuth } from './contexts/AuthContext';
import TaskerServiceOfferingEdit from "./components/Plumber/TaskerServiceOfferingEdit";
import JobProgrees from "./components/Plumber/JobProgress";
import SendOffer from "./components/Plumber/SendOffer";
import ViewOffers from './components/Customer/ViewOffers';
import Privacy from './components/Privacy';
import Terms from './components/Terms';
import ContactUs from './components/ContactUs';
import AboutUs from './components/AboutUs';
import FAQ from './components/FAQ';
import BecomeTasker from './components/BecomeATasker';
import Links from './components/Links';

function App() {
   const { logout } = useAuth();
    
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Landing />} />
         <Route path="/auth" element={<Auth />} />
         <Route path="/privacy" element={<Privacy />} />
         <Route path="/terms" element={<Terms />} />
         <Route path="/contact" element={<ContactUs />} />
         <Route path="/about" element={<AboutUs />} />
         <Route path="/faq" element={<FAQ />} />
         <Route path="/become-a-tasker" element={<BecomeTasker />} />
         <Route path="/links" element={<Links />} />
        
         {/* Customer Routes */}
        <Route
          path="/customer/home"
          element={
            <RequireAuth allowedRoles={['customer']}>
              <CustomerHome onLogout={logout} />
            </RequireAuth>
          }
        />
        <Route 
          path="/customer/edit-profile" 
          element={
            <RequireAuth allowedRoles={['customer']}>
              <CustomerProfileEdit />
            </RequireAuth>
         } 
        />
        <Route
          path="/customer/my-requests"
          element={
            <RequireAuth allowedRoles={['customer']}>
              <MyRequests />
            </RequireAuth>
          }
        />
        <Route
          path="/customer/plumber/:id"
          element={
            <RequireAuth allowedRoles={['customer']}>
              <PlumberProfile />
            </RequireAuth>
          }
        />
        <Route
          path="/customer/job-details/:taskerId"
          element={
            <RequireAuth allowedRoles={['customer']}>
              <JobDetails />
            </RequireAuth>
          }
        />
        <Route
          path="/customer/booking/job/:jobId"
          element={
            <RequireAuth allowedRoles={['customer']}>
              <BookingSchedule />
            </RequireAuth>
          }
        />
        <Route
          path="/customer/booking/request/:requestId"
          element={
            <RequireAuth allowedRoles={['customer']}>
              <BookingSchedule />
            </RequireAuth>
          }
        />
        <Route
          path="/customer/payment/job/:jobId"
          element={
            <RequireAuth allowedRoles={['customer']}>
              <Payment />
            </RequireAuth>
          }
        />
        <Route
          path="/customer/payment/request/:requestId"
          element={
            <RequireAuth allowedRoles={['customer']}>
              <Payment />
            </RequireAuth>
          }
        />
        <Route
          path="/customer/order-status/:jobId"
          element={
            <RequireAuth allowedRoles={['customer']}>
              <OrderStatus />
            </RequireAuth>
          }
        />
        <Route
          path="/customer/review/:jobId"
          element={
            <RequireAuth allowedRoles={['customer']}>
              <Review />
            </RequireAuth>
          }
        />
        <Route
          path="/customer/view-offers/:requestId"
          element={
            <RequireAuth allowedRoles={['customer']}>
              <ViewOffers />
            </RequireAuth>
          }
        />
        
        {/* Tasker Routes */}
        <Route
          path="/tasker/dashboard"
          element={
            <RequireAuth allowedRoles={['tasker']}>
              <TaskerDashboard onLogout={logout} />
            </RequireAuth>
          }
        />
        <Route 
          path="/tasker/edit-profile" 
          element={
            <RequireAuth allowedRoles={['tasker']}>
             <TaskerProfileEdit />
            </RequireAuth>
          } 
        />
        <Route
          path="/tasker/job-request/:jobId"
          element={
            <RequireAuth allowedRoles={['tasker']}>
              <JobRequest />
            </RequireAuth>
          }
        />
        <Route
          path="/tasker/job-progress/:jobId"
          element={
            <RequireAuth allowedRoles={['tasker']}>
              <JobProgrees />
            </RequireAuth>
          }
        />
        <Route
          path="/tasker/send-offer/:requestId"
          element={
            <RequireAuth allowedRoles={['tasker']}>
              <SendOffer />
            </RequireAuth>
          }
        />
        <Route
          path="/tasker/earnings"
          element={
            <RequireAuth allowedRoles={['tasker']}>
              <TaskerEarnings />
            </RequireAuth>
          }
        />
        <Route
          path="/tasker/service-offerings/:id/edit"
          element={
            <RequireAuth allowedRoles={['tasker']}>
              <TaskerServiceOfferingEdit />
            </RequireAuth>
          }
        />
        {/* Admin Routes */}
        <Route
          path="/admin/dashboard"
          element={
            <RequireAuth allowedRoles={['admin']}>
              <AdminDashboard onLogout={logout} />
            </RequireAuth>
          }
        />
      </Routes>
    </div>
  );
}

export default App;

